import { TreeItem } from '@mui/x-tree-view';
import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';


interface Props {
    data: any;
    renderLabel: Function;
    children?: React.ReactNode;
    currentId: string;
}

const RoleCustomTreeItem: React.FunctionComponent<Props> = (props) => {

    const { data, renderLabel, children, currentId } = props;

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
    };

    return (
        <TreeItem key={currentId} itemId={currentId} label={
            <div onClick={handleClick}>
                {
                    renderLabel(`${data.label}$${data.role}$${data.disabled}`, data)
                }
            </div>
        }>
            {children}
        </TreeItem>
    );
}

export default RoleCustomTreeItem;